export enum AuthTypeOption {
  Basic = 0,
  Token = 1,
}

export enum Provider {
  Custom = 0,
  GitHub = 1,
  GitLab = 2,
  BitbucketCloud = 3,
  BitbucketDataCenter = 4,
  AzureDevOps = 5,
  GiteaForgejo = 6,
}
